import { define } from '../../define.js';
import { InputStepper } from './input-stepper.js';
export * from './input-stepper.js';
define('input-stepper', InputStepper);
